






import { Component, Mixins } from "vue-property-decorator";

/**
 * Microsoft.mshtml.dllの機能で直接操作されるDOMを格納しています
 */
@Component({
})
export default class InvisibleController extends Mixins() {
  closeWindow(): void {
    this.postMessage("closeWindow");
  }

  private postMessage(command: string): void {
    const message = JSON.stringify({ key: command });
    window.postMessage(message, "*");
  }
}
